export default function About() {
  return (
    <div className="flex items-center flex-col flex-wrap p-10 my-5">
      <img src="/booking.png" className="h-32" alt="Pousada Casa Kuava" />
      <h3 className="text-center p-5 text-2xl font-light">Uma Pousada Excepcional</h3>
      <p className="text-center">
        A Pousada Casa Kuavá é uma das mais bem avaliadas no Booking em Maragogi-AL
      </p>
    </div>
  )
}